import React, { Component, PropTypes } from 'react';
import { observable, action, toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router';
import HierTable from '../HierTable';
import { token } from "../../libs/localStorage";
import Spinner from '../Spinner';

@inject('stationStore', 'folderStore', 'rolePermissionStore')
@observer
class StationList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };

  folderColumns = [
    // { key: 'id', label: 'ID' },
    { key: 'project', label: 'Project' },
    { key: 'station', label: 'Stations' },
    { key: 'description', label: 'Description' },
    { key: 'total_stations', label: 'Total Stations' },
  ];
  // folderColumns = [
  // { key: 'id', label: 'ID' },
  // { key: 'name', label: 'Project Name' },
  // { key: 'description', label: 'Description' },
  // ];
  stationColumns = [
    { key: 'id', label: 'ID' },
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Station Name' },
    { key: 'description', label: 'Description' },
  ];

  @observable tableData = [];

  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
    this.handleDeleteStation = this.handleDeleteStation.bind(this);

  }

  componentWillMount() {
    const { stationStore, folderStore } = this.props;
    const { notify } = this.context;
    if (!stationStore.isLoading && !stationStore.items.length) stationStore.fetchItems();
    if (!folderStore.isLoading && !folderStore.items.length) folderStore.fetchItems().catch(notify.error);
  }

  handleDelete(idOrIds, type, folderId) {
    const { notify } = this.context;
    const { folderStore } = this.props;
    if (type === 'PROJECT') {
      // notify.startLoading({ message: 'Deleting Folder' });
      // setTimeout(() => {
      folderStore.removeItems(idOrIds)
        .then(res => {
          notify.stopLoading();
          notify.success({ message: 'Folder Deleted' });
          return res;
        })
        .catch(err => {
          notify.stopLoading();
          notify.error(err);
        });
      // }, 5000)
    }
    if (type === 'STATION') {
      notify.startLoading({ message: 'Deleting Station' });

      folderStore.stationStore.removeItems(idOrIds)
        .then(res => {
          folderStore.removeStation(folderId, idOrIds);
          notify.stopLoading();
          notify.success({ message: 'Station Deleted' });
          return res;
        })
        .catch(err => {
          notify.stopLoading();
          notify.error(err);
        });
    }
  }

  handleDeleteStation(idOrIds) {
    this.props.folderStore.stationStore.removeItems(idOrIds);
  }

  render() {
    const { stationStore, folderStore, rolePermissionStore, children } = this.props;

    if (stationStore.isLoading || folderStore.isLoading || rolePermissionStore.isLoading) return <Spinner />

    let tableData = folderStore.processFolderHierarchy(token.getDecoded().role_id === 1 ? folderStore.items : folderStore.items.filter(item => item.stations && item.stations.length > 0));
    return (
      <div>
        {rolePermissionStore.validateRole('modify folder') && <Link className="small button" to={'folder/add'}>Add Project</Link>}
        {rolePermissionStore.validateRole('modify station') && <Link className="small button" to={'folder/-1/station/add'}>Add Station</Link>}
        {rolePermissionStore.validateRole('modify station') && <Link className="small button" to={'folder/export'}>Export Stations</Link>}
        {rolePermissionStore.validateRole('modify station') && <Link className="small button" to={'folder/import'}>Import Stations</Link>}
        <HierTable
          data={tableData}
          slug={'folder'}
          columns={this.folderColumns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resources={{ parent: 'folder', child: 'station' }}
        />
        {children}
      </div>
    );
  }
}

export default StationList;



// WEBPACK FOOTER //
// ./src/components/Station/StationList.js